<template>
    <tr>
        <td><i @click="check(item.id)" class="fa" :class="contains(item.id)<0?'fa-circle-o':'fa-check-circle'"></i></td>
        <td><img v-bind:src="'./images/alle_release/' + item.name + '.png'"></td>
        <td>
            <h3>{{ item.name }}</h3>
            <h4>{{ item.other }}</h4>
            <h6>{{ item.titel }} Titel mit Betailigung</h6>
        </td>
    </tr>
</template>

<script>
    export default {
        name: "Alle_release_item",
        props: ['item'],
        data() {
            return {
                checked: [2, 3],
            }
        }
        ,
        methods: {
            check(id) {
                let index = this.contains(id);
                if (index < 0) {
                    this.checked.push(id);
                } else {
                    this.checked.splice(index, index + 1);
                }
                console.log(this.checked);
            }
            ,
            contains(id) {
                let index = this.checked.indexOf(id);
                return index;

            }

        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/style';

    td {
        padding: 11px 2px;
        vertical-align: middle;

        &:nth-of-type(1) {
            width: 12.5%;
        }

        &:nth-of-type(2) {
            width: 29%;

        }

        i {
            font-size: 2.8rem !important;

            &.fa-check-circle {
                color: $check-circle_color;
            }

            &.fa-circle-o {
                color: $o-circle_color;
            }


            span {
                padding-left: 4px;
                font-size: 1.5rem;
                font-family: "SF UI Text Light";
                font-weight: 300;
            }
        }

        h3{
            font-family: "SF UI Text Light";
            font-size:1.55rem;
            margin-top:0px;
            margin-bottom:2px;
            font-weight:800;
        }
        h6{
            margin-top:7px;
            font-size: 1.3rem;
            color: #4a4a4a;;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/meine_trends/Alle_release_item.vue